import { makeStyles } from '@material-ui/core';
import zeissLogo from './zeiss-logo-32.svg';

const useStyles = makeStyles({
  svg: {
    width: 32,
    height: 32,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      src={zeissLogo}
      alt="ZEISS Logo"
      className={classes.svg}
    />
  );
};

export default LogoIcon;
